import Vue from 'vue';
import VueResource from 'vue-resource';
import Bugsnag from '@bugsnag/js';
import BugsnagPluginVue from '@bugsnag/plugin-vue';

Bugsnag.start({
    apiKey: '76b56839f62e4e593e872ddb5347895e',
    plugins: [new BugsnagPluginVue()],
    releaseStage: process.env.NODE_ENV || 'production'
});

Bugsnag.getPlugin('vue').installVueErrorHandler(Vue);

window._ = require('lodash');

Vue.use(VueResource);

Vue.http.interceptors.push((request, next) => {
    request.headers['X-CSRF-TOKEN'] = document.getElementsByName('csrf-token')[0].content;

    next();
});
